export enum HTTP_RESPONSES {
  // Informative
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  // Success
  Ok = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
  // Client Error
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnprocessableEntity = 422,
  // Server Error
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504
}

export const GENERIC_HTTP_ERR_MESSAGES = {
  [HTTP_RESPONSES.NoContent]: "No Content",
  [HTTP_RESPONSES.BadRequest]: "Bad Request",
  [HTTP_RESPONSES.Unauthorized]: "Unauthorized",
  [HTTP_RESPONSES.Forbidden]: "Forbidden",
  [HTTP_RESPONSES.NotFound]: "Not Found",
  [HTTP_RESPONSES.UnprocessableEntity]: "Unprocessable Entity",
  [HTTP_RESPONSES.InternalServerError]: "Internal Server Error",
  [HTTP_RESPONSES.NotImplemented]: "Not Implemented",
  [HTTP_RESPONSES.BadGateway]: "Bad Gateway",
  [HTTP_RESPONSES.ServiceUnavailable]: "Service Unavailable",
  [HTTP_RESPONSES.GatewayTimeout]: "Gateway Timeout"
}
